// MUI components
import FaiBox from "../../MuiComponents/FaiBox";
import FaiTypography from "../../MuiComponents/FaiTypography";
import FaiInput from "../../MuiComponents/FaiInput";
import { Tooltip } from "@mui/material";
import ErrorRounded from "@mui/icons-material/ErrorRounded";
// Define the props type
interface FormFieldProps {
	label: string;
	note?: string;
	error?: string | boolean;
	isRequired?: boolean;
	[key: string]: any; // Allow any additional props
}

const FormField: React.FC<FormFieldProps> = ({
	label,
	note = null,
	caption = null,
	isRequired = false,
	error = "",
	...rest
}) => {
	return (
		<>
			{label !== undefined && (
				<FaiBox className="flex justify-between items-center" mb={1}>
					<FaiTypography
						className="!text-base leading-6 !font-medium"
						component="label"
						variant="caption"
						textTransform="capitalize"
					>
						{label}
						{isRequired && <span className="text-red-600">*</span>}
					</FaiTypography>
					{note && (
						<Tooltip title={note}>
							<ErrorRounded color="disabled" />
						</Tooltip>
					)}
				</FaiBox>
			)}
			<FaiInput {...rest} error={!!error} />
			{caption && (
				<span className="text-slate-500 text-sm font-medium">{caption}</span>
			)}
			{error && typeof error === "string" && (
				<div className="text-red-500 text-sm font-medium">{error}</div>
			)}
		</>
	);
};

export default FormField;
